<template>
  <div class="p4b__parent p4b__pb-40 makePayment_wrapper_pb">
    <div class="container makePayment_container_bp">
      <div class="p4b__toc-logo mpc_logo">
        <img
          :src="logoImg"
          alt="Logo"
        >
      </div>
      <b-card class="p4b__make-payment-card makePayment_card_pb">
        <b-card-text class="p4b__make-payment-card__content">
          <template v-if="loading">
            <p>Loading payment details...</p>
          </template>
          <template v-else-if="!validToken">
            <h4>Payment link unavailable</h4>
            <p>{{ errorMessage }}</p>
          </template>
          <template v-else-if="alreadyPaid">
            <h4>{{ orderNo }} is fully paid</h4>
            <p>This order has no outstanding balance. No further payment is needed.</p>
          </template>
          <template v-else>
            <h4>Make Payment for {{ orderNo }}</h4>
            <p>Please take a moment to complete your payment for your item for your upcoming service/appointment. The link is valid for a limited time, so kindly ensure you make the payment before it expires.</p>
            <p>This link is specifically for <strong>{{ orderNo }}</strong>. Thank you!</p>
            <p>This payment link will expire on <span>{{ expiryText }}</span>.</p>
            <b-button
              class="p4b__payment-btn-common mpc_btn"
              block
              :to="{ name: 'pay-order-frontend-review', params: { token: $route.params.token } }"
            >
              <feather-icon
                icon="ArrowRightIcon"
                size="12"
                style="vertical-align: middle;"
              />
              Let’s get started!
            </b-button>
          </template>
        </b-card-text>
      </b-card>
      <div class="p4b__make-payment-logo">
        <p>
          <feather-icon
            icon="ShieldIcon"
            size="14"
          /> Secure payment
        </p>
        <div class="p4b__logo-wrapper">
          <b-img
            :src="visaCard"
            height="10.32px"
            alt="visaCard"
          />
          <b-img
            :src="masterCard"
            height="20px"
            alt="masterCard"
          />
          <b-img
            :src="payNow"
            height="18px"
            alt="payNow"
          />
          <b-img
            :src="googlePay"
            height="22px"
            alt="googlePay"
          />
          <b-img
            :src="grabPay"
            height="20px"
            alt="grabPay"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton, BCard, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BImg,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/p4b/logo-yellow.png'),
      // eslint-disable-next-line global-require
      visaCard: require('@/assets/images/frontend/p4b/payment-logo/visa_4x.png'),
      // eslint-disable-next-line global-require
      masterCard: require('@/assets/images/frontend/p4b/payment-logo/master_4x.png'),
      // eslint-disable-next-line global-require
      grabPay: require('@/assets/images/frontend/p4b/payment-logo/grabpay_4x.png'),
      // eslint-disable-next-line global-require
      payNow: require('@/assets/images/frontend/p4b/payment-logo/paynow_4x.png'),
      // eslint-disable-next-line global-require
      googlePay: require('@/assets/images/frontend/p4b/payment-logo/googlepay_4x.png'),

      loading: true,
      validToken: false,
      alreadyPaid: false,
      errorMessage: '',
      orderNo: '',
      expiryText: '',
    }
  },

  beforeMount() {
    document.body.classList.add('p4b__payment-bg')
  },

  mounted() {
    this.loadPaymentLink()
  },

  methods: {
    loadPaymentLink() {
      this.$http.get(`front-end/pay-order/${this.$route.params.token}/validate`)
        .then(res => {
          this.loading = false
          this.validToken = !!res.data.validToken
          if (!this.validToken) {
            this.errorMessage = res.data.message || 'This payment link is invalid or has expired.'
            return
          }
          this.alreadyPaid = !!res.data.alreadyPaid
          this.orderNo = res.data.order.stringID
          this.expiryText = this.dateFormatWithTime(res.data.expiresAt)
        })
        .catch(() => {
          this.loading = false
          this.validToken = false
          this.errorMessage = 'Unable to load this payment link. Please try again later.'
        })
    },
  },
}
</script>
